import { styled } from '@atom-web/core'
import Link from 'next/link'

const AncherTag = styled('a', {
	fontSize: 14,
	fontWeight: 400,
	color: '$collapsible-link',
	textDecoration: 'none',
	'@lg': {
		'&:hover': {
			fontWeight: 700,
			color: '$collapsible-link-hover',
		},
	},
})

const StyledLink = ({ as, children, className, href = '', onClick }) => {
	if (!href) {
		return null
	}

	return (
		<Link href={href} as={as} passHref>
			<AncherTag className={className} onClick={onClick}>
				{children}
			</AncherTag>
		</Link>
	)
}

export default StyledLink
